<template>
    <div>
        <breadCrumb 
            :icon="'fa-user-check'"
            :category="$t(`sideNav.navSalonReport`)"
            :subCategory="$t(`subMenu.my_salon_rewardqr`)"
            :subSubCategory="''">
        </breadCrumb>
        <div class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr border-bottom-0 pt-3 d-block">
                    <rewardQRFilter ref="rewardQRFilter" @filterRewardQRItem="filterRewardQRItems" @searchList="searchList"></rewardQRFilter>
                </div>
                <div class="panel-container show">
                    <div class="panel-content">
                        <div class="tab-content mt-2">
                            <rewardQRView ref="rewardQRView" @setStaffFilter="setStaffFilter" @setExportData="setExportData"></rewardQRView>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import BreadCrumb from './../../Bread_Crumb'
import RewardQRFilter from './RewardQR_Filter'
import RewardQRView from './RewardQR_View'

export default {
    name: "menuRewardQR",
    components:{
        RewardQRFilter, RewardQRView, BreadCrumb
    },
    data(){
        return {
            filterObj: {}, 
        }
    },
    methods:{
        filterRewardQRItems(filterObj){
            this.filterObj = filterObj;
            this.$refs.rewardQRView.setRewardQRItems(this.filterObj);
        },
        setStaffFilter(data, staff){
            this.$refs.rewardQRFilter.setStaffFilter(data, staff)
        },
        setExportData(data){
            this.$refs.rewardQRFilter.setExportData(data)
        },
        searchList(search){
            this.$refs.rewardQRView.searchList(search);
        }
    }
}
</script>
<style scoped>
.nav-link{
    cursor: pointer;
}
</style>